import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const Timeline = dynamic(() => import('./Timeline'));

const TimelineConfig = {
  name: 'Timeline',
  inputs: [
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'date',
          friendlyName: 'Date/time',
          type: 'string',
        },
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'content',
          type: 'longText',
        },
      ],
    },
  ],
};

Builder.registerComponent(Timeline, TimelineConfig);
